<input-text #filterTextBox [inputId]="inputId" [isSearchField]="true"
            [value]="multiSelect.filterValue"
            [required]="false"
            [ariaLabel]="searchAriaLabel"
            [comboboxMode]="true"
            [ariaControls]="listboxId"
            [ariaActiveDescendant]="activeOptionId"
            [isDisabled]="readOnly"
            placeHolderText="{{'multi.select.filter.placeholder' | translate}}"
            (onTextChange)="onFilterChanged($event)"
            (onSearchReset)="onFilterReset()"
></input-text>
<div class="actions" *ngIf="displaySelectOptions">
  <button type="button" class="action select-all" title='{{"multi.select.select.all" | translate}}' (click)="onSelectAll()">{{"multi.select.select.all" | translate}}</button>
  <button type="button" class="action clear-all" title='{{"multi.select.clear.all" | translate}}' (click)="onClearAll()">{{"multi.select.clear.all" | translate}}</button>
</div>

